// Copyright (c) 2025 Deere & Company

import React, {PropTypes} from 'react';
import DealerRecommendationConfirmModal from '../state/dealer-recommendation-confirm-modal';
import DealerRecommendationModalBody from './dealer-recommendation-modal-body';
import DealerRecommendationModalHeader from './dealer-recommendation-modal-header';
import {WarrantyMediumModal} from '../../../shared/components/modal';

const DealerRecommendationModal = props =>
    <section className='dealer-recommendation-modal'>
        <WarrantyMediumModal isOpen={props.dealerRecommendationModal.isVisible}>
            <DealerRecommendationModalHeader
                closeDealerRecommendationModal={props.closeDealerRecommendationModal}
                dealerRecommendationModalAction={props.dealerRecommendationModal.actionToTake}

            />
            <DealerRecommendationModalBody
                dealerRecommendationModalAction={props.dealerRecommendationModal.actionToTake}
                onConfirmation={props.onConfirmation}
            />
        </WarrantyMediumModal>
    </section>;

DealerRecommendationModal.displayName = 'DealerRecommendationModal';
DealerRecommendationModal.propTypes = {
    closeDealerRecommendationModal: PropTypes.func.isRequired,
    dealerRecommendationModal: PropTypes.instanceOf(DealerRecommendationConfirmModal),
    onConfirmation: PropTypes.func.isRequired
};

export default DealerRecommendationModal;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation-modal.js